import { z } from '@betty/toolkit/api';

const PromotionTypeSchema = z.enum([
  'Streaks',
  'InPeriod',
  'Welcome',
  'Action',
  'Static',
  'Cashback',
  'InstantReward',
]);

const SubPromotionTypeSchema = z.enum([
  'SpinCount',
  'Referral',
  'Custom',
  'Generic',
  'Deposit',
  'NetLosses',
  'Onboarding',
  'BetAmount',
]);

export const PromotionRewardTargetSchema = z.enum([
  'Bonus',
  'Cash',
  'FreeSpins',
  'Coins',
  'InstantWheel',
  'BettyPoints',
]);

const PromotionStatusSchema = z.enum([
  'Available',
  'Locked',
  'InProgress',
  'InProgressQualified',
  'NotQualified',
  'Qualified',
  'OptIn',
  'OptOut',
  'Expired',
]);

const PromotionRewardSchema = z.object({
  rewardTarget: PromotionRewardTargetSchema,
  rewardAmount: z.number().optional(),
});

const SubTypeMetaSchema = z.object({
  referrerName: z.string().optional(),
  referrerId: z.number().optional(),
  currentAccumulation: z.number().optional(),
  targetAccumulation: z.number().optional(),
  expiryDate: z.string().optional(),
  gameIds: z.array(z.number()).optional(),
  startDate: z.string().optional(),
  minimumQualificationAmount: z.number().optional(),
  percentage: z.number().optional(),
  maximumRewardAmount: z.number().optional(),
  isInLadderPromotion: z.boolean().optional(),
});

export const PromotionSchema = z.object({
  title: z.string(),
  isOptedIn: z.boolean(),
  promotionId: z.number(),
  status: PromotionStatusSchema,
  rewards: z.array(PromotionRewardSchema),
  rewardDescription: z.string().optional(),
  lockedDescription: z.string().optional(),
  miniImageUrl: z.string().optional(),
  subTypeMeta: SubTypeMetaSchema.optional(),
  promoType: PromotionTypeSchema.optional(),
  subPromoType: SubPromotionTypeSchema.optional(),
  termsAndConditions: z.string(),
});

export const OptInSchema = z.object({}).optional();

export const OptOutSchema = z.object({}).optional();
